export const GET_LEGAL_DOCUMENTS = 'GET_LEGAL_DOCUMENTS'
export const GET_LEGAL_DOCUMENTS_SUCCESS = 'GET_LEGAL_DOCUMENTS_SUCCESS'
export const GET_LEGAL_DOCUMENTS_FAILURE = 'GET_LEGAL_DOCUMENTS_FAILURE'

export const GET_LEGAL_DOCUMENT_BY_ID = 'GET_LEGAL_DOCUMENT_BY_ID'
export const GET_LEGAL_DOCUMENT_BY_ID_SUCCESS =
  'GET_LEGAL_DOCUMENT_BY_ID_SUCCESS'
export const GET_LEGAL_DOCUMENT_BY_ID_FAILURE =
  'GET_LEGAL_DOCUMENT_BY_ID_FAILURE'

export const CREATE_LEGAL_DOCUMENT = 'CREATE_LEGAL_DOCUMENT'
export const CREATE_LEGAL_DOCUMENT_SUCCESS = 'CREATE_LEGAL_DOCUMENT_SUCCESS'
export const CREATE_LEGAL_DOCUMENT_FAILURE = 'CREATE_LEGAL_DOCUMENT_FAILURE'

export const UPDATE_LEGAL_DOCUMENT_BY_ID = 'UPDATE_LEGAL_DOCUMENT_BY_ID'
export const UPDATE_LEGAL_DOCUMENT_BY_ID_SUCCESS =
  'UPDATE_LEGAL_DOCUMENT_BY_ID_SUCCESS'
export const UPDATE_LEGAL_DOCUMENT_BY_ID_FAILURE =
  'UPDATE_LEGAL_DOCUMENT_BY_ID_FAILURE'

export const DELETE_LEGAL_DOCUMENT_BY_ID = 'DELETE_LEGAL_DOCUMENT_BY_ID'
export const DELETE_LEGAL_DOCUMENT_BY_ID_SUCCESS =
  'DELETE_LEGAL_DOCUMENT_BY_ID_SUCCESS'
export const DELETE_LEGAL_DOCUMENT_BY_ID_FAILURE =
  'DELETE_LEGAL_DOCUMENT_BY_ID_FAILURE'

export const UPLOAD_LEGAL_DOCUMENT_TO_S3 = 'UPLOAD_LEGAL_DOCUMENT_TO_S3'
export const UPLOAD_LEGAL_DOCUMENT_TO_S3_SUCCESS =
  'UPLOAD_LEGAL_DOCUMENT_TO_S3_SUCCESS'
export const UPLOAD_LEGAL_DOCUMENT_TO_S3_FAILURE =
  'UPLOAD_LEGAL_DOCUMENT_TO_S3_FAILURE'
